import React  from 'react';

import {Col} from 'react-bootstrap';
import noPostsFound from '../homepage/images/no-posts.svg';
import {Button} from '@material-ui/core';

export default function NoData(props) {
    return(
        <Col md='12'  className="text-center pt-3 pb-5" >
            <h2 className="text-dark">{props.title && props.title}</h2>
            <p className="text-grey">{props.description && props.description}</p>
            <div className="pt-3 pb-1">
                <img src={props.img ? props.img : noPostsFound} alt="No Posts" className="img-fluid" />
            </div>
            <div>
            </div>
            {/* <div>
                <Button size="large" varient="outlined" className="btn-orange-gradiant pr-5 pl-5">Post Job</Button>
            </div> */}
    </Col>
    )
}